










































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator"
import _ from "lodash"

@Component
export default class BusinessUpdateContactForm extends Vue {
  @Prop({ default: () => ({}) }) businessContact!: Model
  @Prop() readonly businessOid!: string
  @PropSync("showSheet") syncedShowSheet!: boolean

  isLoading = false

  handleSubmitContact() {
    this.isLoading = true
    const action = this.businessContact.object_id
      ? "BusinessContact/update"
      : "BusinessContact/create"
    this.$store
      .dispatch(action, {
        ...this.businessContact,
        business_oid: this.businessOid
      })
      .then(() => {
        this.$store
          .dispatch("Business/fetch", {
            businessOid: this.businessOid,
            config: {
              params: {
                expand: [
                  "business_contacts",
                  "business_addresses",
                  "billing_address",
                  "billing_contact",
                  "postal_address",
                  "primary_contact",
                  "director_contact",
                ]
              }
            }
          })
          .then(() => {
            this.isLoading = false
            this.syncedShowSheet = false
          })
      })
      .catch(() => {
        this.isLoading = false
      })
  }

  isEmpty(v) {
    return _.isEmpty(v)
  }
}
